module.exports = __webpack_public_path__ + "img/threads.354f0a4a.svg";